<!--
  @Description: 我的关注-底部推荐
  @Author: wang.y 
  @Date: 2022-02-25 
-->
<template>
  <div class="reco">
    <div class="reco-top">
      <div class="tilte">您可能感兴趣</div>
      <div class="search">
        <search-entity></search-entity>
      </div>
    </div>
    <div class="reco-container">
      <div>
        <div class="reco-name">推荐公司</div>
        <div class="reco-list">
          <entity-temp :position="1" v-for="item,index in complist" :key="index" :item="item" :entitytype="0" :reco="1"></entity-temp>
        </div>
      </div>
      <div>
        <div class="reco-name">明星机构</div>
        <div class="reco-list">
          <entity-temp :position="2" v-for="item,index in orglist" :key="index" :item="item" :entitytype="1" :reco="1"></entity-temp>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EntityTemp from './EntityTemp'
import SearchEntity from './SearchEntity'
export default {
  components: {
    EntityTemp, SearchEntity
  },
  created() {

  },
  mounted() { },
  props: ['orglist', 'complist'],
  data() {
    return {
      
    }
  },
  computed: {},
  methods: {
    
  }
}
</script>
<style lang="stylus" scoped>
.reco
  margin-top 30px
  &-top
    display flex
    justify-content space-between
    align-items center
    .tilte
      font-size 20px
      color #333333
      position relative
      line-height 1
      z-index 1
      &::before
        content ''
        position absolute
        background rgba(255, 186, 128, 1)
        height 6px
        width 100%
        bottom -3px
        z-index -1
  &-container
    margin-top 20px
    display flex
    > div
      flex 0 0 540px
      padding 20px
      background #F8F9FA
      & + div
        margin-left 10px
      .reco-name
        font-size 16px
      .reco-list
        display grid
        grid-template-columns repeat(2, 240px)
        grid-template-rows 60px
        grid-gap 16px 20px
        grid-auto-columns 240px
        grid-auto-rows 60px
        justify-content space-between
        margin-top 20px

</style>